import {
  selectAboutTLW,
  selectClause,
  selectCustomerService,
  useFooterApi,
} from '../api';
import { RecommendInfo } from './recommend-info/RecommendInfo';
import { CompanyInfo } from './company-info/CompanyInfo';
import {
  useBuriedPoint,
  type BuriedPoint,
  type BuriedPointProduct,
} from '../../common';
import { useMemo } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FooterProps {}

export function Footer(props: FooterProps) {
  const { data: response, isFetched } = useFooterApi();

  const list = useMemo(() => {
    const footerData = response?.data;
    return [
      ...selectAboutTLW(footerData),
      ...selectCustomerService(footerData),
      ...selectClause(footerData),
    ];
  }, [response?.data]);

  const { tagAttributes } = useBuriedPoint('ad', {
    data: useMemo<Partial<BuriedPoint>>(
      () => ({
        ad_creative_slot: 'homepage',
        ad_creative_name: 'footer',
        ad_promotion_id: 'footer',
        ad_promotion_name: 'footer',
        items: list.map((item) => {
          return {
            item_id: item.link,
            item_name: item.mainHeading,
          } as BuriedPointProduct;
        }),
      }),
      [list]
    ),
    enabled: isFetched,
  });

  return (
    <footer
      className="tlw-mt-6 tlw-px-6 tlw-pt-8 tlw-pb-10 tlw-flex tlw-flex-col tlw-gap-5 tlw-bg-gray-100 lg:tlw-px-20 lg:tlw-pt-[100px] lg:tlw-pb-20 lg:tlw-flex-row lg:tlw-justify-between"
      id="NoFooter"
      {...tagAttributes}
    >
      <RecommendInfo />

      <CompanyInfo />
    </footer>
  );
}
